"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCatalogsExportColumns = void 0;
function createCatalogsExportColumns() {
    return [
        {
            field: 'warengruppe',
            headerName: 'Warengruppe',
            editable: false,
            initialWidth: 300,
            type: 'derivedColumn',
        },
        {
            field: 'botanisch',
            headerName: 'Botanisch',
            editable: false,
            initialWidth: 250,
            type: 'derivedColumn',
        },
        {
            field: 'gattung',
            editable: false,
            headerName: 'Gattung',
            type: 'derivedColumn',
            initialWidth: 150,
        },
        {
            field: 'new',
            editable: true,
            headerName: 'Neu',
            initialWidth: 100,
            type: 'booleanColumn',
        },
        {
            field: 'deutsch_kurz',
            headerName: 'Deutscher Name',
            editable: false,
            type: 'derivedColumn',
            initialWidth: 150,
        },
        {
            field: 'catalog_name',
            headerName: 'Deutscher Name Katalog',
            editable: true,
            minWidth: 600,
            initialWidth: 600,
        },
    ];
}
exports.createCatalogsExportColumns = createCatalogsExportColumns;
